import React from 'react'
import {connect} from "react-redux"

import VideoThumb from '../video/VideoThumb'
import DoneImg from '../ui/images/check_circle_white.svg'
import Avatar from '../user/Avatar'
import ShowCategories from '../ui/ShowCategories'


import moment from 'moment'
import editImage from '../../images/icons/edit_black.svg';
//import {fetchSessions} from '../../actions/patient'
import arrowRight from '../therapist/images/arrow-right.svg'
import folderSVG from '../therapist/images/folder-solid.svg'
import arrowRightDark from '../therapist/images/arrow-right-dark.svg'
import ThumbUpImg from '../../images/icons/thumb_up_black.svg'

const closeStyle = {
	position: 'absolute',
  top: '8px',
  right: '8px'
}
@connect((store) => {
	return {
    therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
    //videos: store.videos,
		modal: store.modal
	}
})
class ParentPatientSessionCard extends React.Component {
	render(){
		let { toggleShowMore, toggleHomework, homework, toggled, index, videos, click,therapy_areas, therapy_categories, notification, handleEdit} = this.props;
		let session = this.props.session.data
function setSessionKey(session) {
		return 'session-' + session._id;
	}
		function setHomeworkId(session) {
		return 'homework-' + setSessionKey(session);
	}

	function age(session){
		return moment().diff(session.patient.dob, 'years')
	}

		return  <div key={setSessionKey(session)} >
		{/* SESSION CARD */}
				<div>
					<ul className="md-list sessionCard card marginless">
						<li className="card-header row marginTopNone">
							<div className="patientSessionOrAssesmentIcon">
								<span>S</span>
							</div>
							<div className="headerInfo">
								<p>
								{
									// session.dateSent? <span>{moment(session.dateSent).format('ddd Do of MMM YYYY')} - { moment(session.dateSent).fromNow()}</span>
									// :
									<span>{moment(session.created).format('ddd Do of MMM YYYY')} - { moment(session.created).fromNow()}</span>
								}
								</p>
								<small>Therapist: {session.therapist.name} | Patient Age: { age(this.props) } years</small>
							</div>
							<div className="headerAction">
								<a onClick={() => {	click(session) }} className="link padding" >OPEN</a>
							</div>
						</li>
						{/* <li className="card-content">
					<p>{session.data.internal_notes}</p>
				</li> */}

						<li className="internalNotes">
                            {/*<h5>Internal Notes:</h5>*/}
                            <div className={ toggled === session._id? 'notesContainer show' : 'notesContainer' }>
                            	{session.parent_notes}
                            </div>
                            {
                            	session.parent_notes &&
	                            <div className="readMoreContainer">
	                            	<a onClick={() => {toggleShowMore(session._id)} }> {toggled === session._id ? 'Read Less': 'Read More'}</a>
								</div>
							}
                        </li>
                        <li>
						{ session.therapy_areas.length !== 0 && <li>
							<ShowCategories
							therapy_areas={session.therapy_areas.map(areaId => therapy_areas[areaId])}
							therapy_categories={therapy_categories}
							/>
							</li>
						}
						</li>
						<li className="homeWorkSection" className={homework === setHomeworkId(session) ? "homeWorkSection show" : "homeWorkSection"}>
							<div onClick={() => { toggleHomework(setHomeworkId(session)) }} className="md-subhead"><a >Homework Areas</a></div>
							<div id={setHomeworkId(session)} className={homework === setHomeworkId(session) ? "video-grid show grid horizontal-row" : "video-grid grid horizontal-row"}>
								<div className="videoContainer">
									{session.videos.map(videoId => <div className="thumb" key={videoId}>
										<div className="card marginless">
											{videos[videoId] && <VideoThumb class="min-video" video={videos[videoId]} />}
											{session.videos_done[videoId] && <img alt="Avatar" src={ThumbUpImg} style={{
												height: '18px',
												position: 'absolute',
												right: '4px',
												bottom: '4px'
											}} />}
										</div>
									</div>)}
								</div>
							</div>
						</li>
						{notification[session._id] > 0 && <div className="notification link" onClick={() => {
							openClick(session)
						}
						}>
							{notification[session._id]}
						</div>}
					</ul>
					<div className="hrAssesment">
						<span></span>
					</div>
				</div>
			{/* SESSION CARD END */}

		{/*<ul className="md-list card high marginless">
		<a className="link " style={closeStyle}>Open</a>
		<li className="card-header  row">
		<Avatar pic={session.therapist.picture} />
		<div className="fill">
		<b>
		{
			session.dateSent? <span>{moment(session.dateSent).format('ddd Do of MMM YYYY')} - { moment(session.dateSent).fromNow()}</span>
			:
			<span>{moment(session.created).format('ddd Do of MMM YYYY')} - { moment(session.created).fromNow()}</span>
		}
		</b>
		</div>
		{ handleEdit && <div
			onClick={()=>{handleEdit(session)}}
			className="edit icon link">
			<img src={editImage} alt="Edit" />
			</div>
		}

		</li>
		<li className="card-content">
		<p>{session.parent_notes}</p>
		</li>
		<li className="section paddingless">
		<hr />
		<div className="md-subhead">Homework</div>
		{
			session.videos.length? <div className="video-grid grid horizontal-row">
			{session.videos.map(videoId => <div className="thumb"  key={videoId}>
				<div className="card dark marginless" style={
					{
						opacity: session.videos_done[videoId]? '1' : '0.6'
					}
				}>
				<VideoThumb class="min-video" video={videos[videoId]}/>
				{ session.videos_done[videoId] && <img alt="Profile avatar" src={DoneImg} style={{
					height: '18px',
					position: 'absolute',
					right:'4px',
					bottom:'4px'
				}} />}
				</div>
				</div>)}
			</div> :
			<span>Nothing for today</span>
		}
		</li>
		{ session.therapy_areas.length !== 0 && <li>
			<ShowCategories
			therapy_areas={session.therapy_areas.map(areaId => therapy_areas[areaId])}
			therapy_categories={therapy_categories}
			/>
			</li>
		}
		<li className={'card-footer primary-shade'+(index%3)}>{session.therapist.name}</li>
		{notification > 0 && <div className="notification link">
		{ notification }
		</div>}
		</ul>*/}
		</div>;
	}


}

ParentPatientSessionCard.defaultProps = {
  patient:{},
	notification: 0,
	session: {},
  therapy_areas:[],
	videos: [],
	editButton:false
}

export default ParentPatientSessionCard



// WEBPACK FOOTER //
// ./src/components/parent/ParentPatientSessionCard.jsx